import { type MouseEvent, useEffect, useRef } from 'react';
import { VITE_API_HOST } from '@/constants';

type TUseWebRtc = {
	showButton?: boolean;
	useLogger?: boolean;
	customerIdn?: string;
	connectorIdn?: string;
	externalActorId: string;
};

const useWebRtcCall = ({
	showButton = false,
	useLogger = false,
	customerIdn,
	connectorIdn,
	externalActorId
}: TUseWebRtc) => {
	const initializedRef = useRef(false);

	const handleOpenWebCall = (ev: MouseEvent<HTMLButtonElement>) => {
		const widget = globalThis.WebCallWidget;

		if (!widget) {
			return;
		}

		ev.preventDefault();
		ev.stopPropagation();

		widget.open('audio');
	};

	useEffect(() => {
		const widget = globalThis.WebCallWidget;
		if (!widget || !customerIdn) {
			return;
		}

		widget.init({
			showButton,
			apiBaseUrl: VITE_API_HOST,
			useLogger,
			customerIdn: customerIdn || '',
			connectorIdn: connectorIdn || '',
			externalActorId
		});

		initializedRef.current = true;
	}, [customerIdn, showButton, useLogger, connectorIdn, externalActorId]);

	return handleOpenWebCall;
};

export default useWebRtcCall;
